import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const BottomAction = ({ className = "", isAuthenticated = false, tenanturlname = "", onNavClick = () => {} }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();

    // Don't render if user is authenticated
    if (isAuthenticated) return null;

    const handleLoginClick = () => {
        onNavClick(); // Close drawer first
        navigate(`/${tenanturlname}/signin`, { replace: true });
    };

    const handleSignupClick = () => {
        navigate(`/${tenanturlname}/create-account`);
        onNavClick();
    };

    return (
        <div className={`flex items-center justify-center bg-theme-primary h-[60px] ${className}`}>
            <button 
                onClick={handleLoginClick}
                className="text-theme-neutral text-base font-normal flex-1 hover:opacity-80 transition-opacity"
            >
                {t("common.login")}
            </button>
            <div className="h-10 w-px bg-white"></div>
            <button 
                onClick={handleSignupClick}
                className="text-theme-neutral text-base font-normal flex-1 hover:opacity-80 transition-opacity"
            >
                {t("common.signup")}
            </button>
        </div>
    );
};

export default BottomAction;
